import { Settings } from 'lucide-react';
import { useT } from '@/lib/i18n';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/lib/routes';
import { Button } from '@/components/ui/button';
import { HasPermission } from '@/components/shared/HasPermission';

/**
 * SettingsButton — icône engrenage vers la page unique « Paramètres » (#14bis).
 * Visible pour l'UNION des trois gardes (perso · système · comptes) : même un
 * utilisateur qui n'a que users.view doit pouvoir l'ouvrir (onglet Utilisateurs).
 */
export function SettingsButton() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <HasPermission permission={['configuration.modifier', 'configuration.modifier', 'utilisateurs.voir']}>
      <Button
        variant="ghost"
        size="sm"
        className="h-8 w-8 p-0"
        aria-label={t('nav.parametres')}
        onClick={() => navigate(ROUTES.parametres)}
      >
        <Settings className="h-4 w-4" />
      </Button>
    </HasPermission>
  );
}
